import Vue from "vue";

let environment = "dev"; //local, dev, or production
let hostname = process.env.MIX_HOSTNAME;
let api_prefix = hostname + "/api/v3";
let customer_prefix = api_prefix + "/customer";
let firebasechat = "/" + process.env.MIX_FIREBASE_CHAT_DATABASE;

const endpoints = {
  hostname,
  environment: environment,
  api_endpoint: `${api_prefix}`,
  pusher_auth: `${hostname}/api/broadcasting/auth`,

  user_login: `${api_prefix}/login`,
  user_google_login: `${api_prefix}/auth/google`,
  user_register: `${api_prefix}/register`,
  user_otp: `${api_prefix}/otp`,
  user_country: `${api_prefix}/country`,
  user_check_exist: `${api_prefix}/check-user`,
  user_renew_password: `${api_prefix}/renew-password`,
  user_app_module: `${api_prefix}/app-module`,

  user_profile: `${api_prefix}/user`,
  user_notifications: `${api_prefix}/user/notification`,
  user_change_password: `${api_prefix}/user/change-password`,
  user_change_email: `${api_prefix}/user/change-email`,
  user_change_phone_number: `${api_prefix}/user/change-phone-number`,
  user_google_account: `${api_prefix}/user/google`,

  article: `${api_prefix}/article`,
  article_type: `${api_prefix}/article/type`,
  article_group: `${api_prefix}/article/group`,

  customer_register: `${customer_prefix}/register`,
  customer_profile: `${customer_prefix}/profile`,
  customer_calculator: `${customer_prefix}/calculator`,
  customer_contact_us: `${api_prefix}/contact-us`,
  customer_home: `${customer_prefix}/home`,
  customer_address_book: `${customer_prefix}/address-book`,

  customer_coupon: `${customer_prefix}/coupon`,
  customer_payment_method: `${customer_prefix}/payment-method`,
  customer_credit_card: `${customer_prefix}/credit-card`,
  customer_wallet: `${customer_prefix}/wallet`,
  customer_wallet_topup: `${customer_prefix}/top-up`,
  customer_wallet_topup_package: `${customer_prefix}/top-up/package`,
  customer_payment: `${customer_prefix}/payment`,
  customer_payment_transaction: `${customer_prefix}/payment/transaction`,
  customer_transfer_request: `${customer_prefix}/top-up/transfer-request`,
  customer_topup_proof: `${customer_prefix}/topup-proof`,
  customer_topup_payment_availability: `${customer_prefix}/top-up/payment-availability`,

  customer_order: `${customer_prefix}/order`,
  customer_invoice: `${customer_prefix}/order/invoice`,
  customer_bulk_order: `${customer_prefix}/bulk-order`,
  customer_order_payment_availability: `${customer_prefix}/order/payment-availability`,
  customer_paynow: `${customer_prefix}/paynow`,
  customer_grabpay: `${customer_prefix}/grabpay`,
  public_validate_note: `${customer_prefix}/order/note/validate`,

  customer_delivery_type: `${customer_prefix}/order/delivery-type`,
  customer_service_type: `${customer_prefix}/order/service-type`,
  customer_service_type_vehicle_type: `${customer_prefix}/order/vehicle-type`,
  customer_good_size: `${customer_prefix}/order/good-size`,
  customer_good_type: `${customer_prefix}/order/good-type`,
  customer_addon: `${customer_prefix}/order/addon`,
  customer_order_term_condition: `${hostname}/api/terms-and-conditions`,
  customer_search_address: `${api_prefix}/address/search`,
  customer_check_forbidden: `${api_prefix}/address/validate`,
  customer_optimize_route: `${api_prefix}/address/optimize-route`,

  customer_countries: `${hostname}/api/all-country`,
  customer_currencies: `${hostname}/api/all-currency`,
  customer_city_postal: `${hostname}/api/city-postal`,
  customer_sicepat_location: `${hostname}/api/sicepat-location`,

  public_livechat: `${hostname}/livechat`,
  customer_download: `${hostname}/download`,
  rates: `${hostname}/download/rates`,
  paynow_qrcode: `${hostname}/assets/images/payments/paynow_account.jpg`,
  bank_transfer: `${hostname}/assets/images/payments/bank_transfer_account.jpg`,
  handbook: `${hostname}/download/customer-handbook`,
  mail_business: "mailto:business@viamove.co?subject = Enquiry on Viamove API Integrations",

  admin_send_chat_notification: `${api_prefix}/send-chat-notification`,
  firebase_chat: "/" + firebasechat,
};

export default endpoints;
